module.exports = __webpack_public_path__ + "static/christmas-stockings-f7f6d2a82006ea7f44bfc437396114a4.png";